/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconLogo/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconLogo({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconLogo",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconLogo.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-IszX': alignSelf,'--mt-2-IszX': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-IszX': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-IszX': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-IszX': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-IszX': opacity,'--w-10-IszX': typeof width === 'number' ? `${width}px` : width,'--h-11-IszX': typeof height === 'number' ? `${height}px` : height,'--a-7-IszX': isAnimated ? animation : "none",'--sd-8-IszX': isAnimated ? strokeDashoffset : 0,'--sd-9-IszX': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconLogo.SvgPath"
  data-view-path={viewPath}
 d="M13.974 11.618c.588 0 1.029-.63 2.393-.966 1.345-1.743 1.639-4.452 1.575-4.64-.084-.19-5.081 2.057-6.068 4.556-.105.252 1.659 1.05 2.1 1.05zm2.12 5.46c-.02 0 0 0 0 0-.02 0-.02 0 0 0z"
 style={{'--f-12-IszX': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="TysiaIconLogo.SvgPath:1"
  data-view-path={viewPath}
 d="M14.646 11.807c-.168.105-.336.231-.546.252-.21.021-.42-.063-.63-.147-3.906-1.638-7.12-3.885-8.022-4.683-.903-.777-3.717 5.313 1.449 7.455 1.239.525 1.806.903 1.575 1.07-.588.42-5.208 1.744-6.363 1.786-.357.02.252.609.567.63.315.02 2.415-.462 4.347-.546.882-.042 2.226.21 2.73.399 1.932.63 4.053-.357 5.963-1.974 1.912-1.617 1.954-1.701 2.479-2.121 2.582-2.037 3.653-1.197 3.8-1.512.147-.315-3.255-3.108-7.35-.609z"
 style={{'--f-12-IszX': fill}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}